<template>
  <div class="ProjectNew">
    <h2 class="subtitle">
      Création d'une nouvelle entrée de projet...
      <button class="button is-transparent is-loading">...</button>
    </h2>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/projects";

export default {
  name: "ProjectNew",
  async mounted() {
    const project = await this.$store.dispatch(t.ASK_NEW_PROJECT);
    setTimeout(() => {
      this.$router.push(`/project/edit/${project.uuid}`);
    });
  }
};
</script>

<style lang="scss">
.ProjectNew {
}
</style>
